export default __webpack_public_path__ + "static/media/Image5.f88b5261.png";